import { Injectable } from "@angular/core";
import { FrameContext } from "@farris/devkit";

@Injectable()
export class ViewModelService {
  constructor() { }
  public getGridColumns(frameContext: FrameContext): any[] {
    const dataGridColumnsName = frameContext && frameContext.viewModel && frameContext.viewModel['dataGridColumnsName'] || null;
    return dataGridColumnsName && frameContext.viewModel[dataGridColumnsName] || [];
  }
}